import { CanActivateFn, Router } from '@angular/router';
import { DestroyRef, inject } from '@angular/core';
import { UserService } from '@aeCore/services/user.service';
import { UserModel } from '@aeCore/interfaces/user.interface';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { USER_DEFAULT_ROUTES } from '@aeCore/constants/user.const';
import { TokenService } from '@aeCore/services/token.service';

export const loginGuard: CanActivateFn = () => {
  const userService = inject(UserService);
  const router = inject(Router);
  const destroyRef = inject(DestroyRef);
  const tokenService = inject(TokenService);

  const accessToken = tokenService.getAccessToken();
  if (accessToken) {
    userService
      .getUserInfo()
      .pipe(takeUntilDestroyed(destroyRef))
      .subscribe((user: UserModel): void => {
        if (user) {
          const userRoutes = USER_DEFAULT_ROUTES[user!.type];
          router.navigate(['/' + userRoutes]);
        }
      });
  }

  return true;
};
